export default __webpack_public_path__ + "static/as-c7e4903aecacf54a21ab46995b15c08e.svg";